export default __webpack_public_path__ + "static/media/古倫維.81159cfa.jpg";